// WhatsApp click-to-chat helper.
// Number is stored WITHOUT the + prefix per wa.me spec.
export const WA_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "";
export const WA_DISPLAY = process.env.REACT_APP_WHATSAPP_DISPLAY || "";

const DEFAULT_MSG =
  "Hello Easyilaaz Concierge — I would like to enquire privately about medical care in India.";

export function waLink(message = DEFAULT_MSG) {
  if (!WA_NUMBER) return "#";
  const t = encodeURIComponent(message);
  return `https://wa.me/${WA_NUMBER}?text=${t}`;
}

export function waMessageFor(context = {}) {
  const { name, specialty, country, kind } = context;
  const bits = ["Hello Easyilaaz Concierge."];
  if (kind === "second_opinion") bits.push("I have just requested a Second Opinion.");
  else if (kind === "consultation") bits.push("I have just submitted a Confidential Consultation request.");
  if (name) bits.push(`My name is ${name}.`);
  if (specialty) bits.push(`Specialty: ${specialty}.`);
  if (country) bits.push(`I am reaching you from ${country}.`);
  bits.push("Kindly continue our conversation here.");
  return bits.join(" ");
}
